import React from "react";

const PublicitySee = ({ isOpen, onClose, publicity }) => {
    if (!isOpen || !publicity) return null;

    return (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
            <div className="bg-white p-6 rounded-lg shadow-lg w-full max-w-3xl">
                <h2 className="text-lg font-bold mb-4 text-center">Detalles de Publicidad</h2>

                <div className="grid grid-cols-2 gap-4">
                    <div>
                        <p><strong>Nombre Comercial:</strong> {publicity.commercialName}</p>
                        <p><strong>Descripción:</strong> {publicity.descriptionPublicity}</p>
                        <p><strong>Sitio Web:</strong> <a href={publicity.link} target="_blank" className="text-blue-500 underline">{publicity.link}</a></p>
                    </div>
                    <div>
                        <p><strong>Fecha Inicio:</strong> {publicity.startDate}</p>
                        <p><strong>Fecha Fin:</strong> {publicity.finishDate}</p>
                        <p><strong>Categoría:</strong> {publicity.category?.description}</p>
                    </div>
                </div>

                {publicity.logo && (
                    <div className="text-center mt-4">
                        <img src={publicity.logo} alt="Logo Publicidad" className="w-40 h-40 object-cover rounded mx-auto" />
                    </div>
                )}

                <div className="flex justify-end mt-6">
                    <button 
                        onClick={onClose} 
                        className="bg-gray-400 text-white px-4 py-2 rounded mr-2"
                    >
                        Cerrar
                    </button>
                </div>
            </div>
        </div>
    );
};

export default PublicitySee;
